import toggleTableColumns from './toggleTableColumns';
import { format } from 'date-fns';

const defaultColumns = [
    {
        value : 'installation',
        label : 'Installation',
        component: 'delivery-project-address-list-item-delivery-phase',
    },
    {
        value : 'dig',
        label : 'Grävning',
        component: 'delivery-project-address-list-item-delivery-phase',
    },
    {
        value : 'activation',
        label : 'Redo för driftsättning',
        component: 'delivery-project-address-list-item-delivery-phase',
    },
    {
        value : 'operational',
        label : 'I drift',
        component: 'delivery-project-address-list-item-delivery-phase',
    },
];

const allColumns = [
    ...defaultColumns,
    { value : 'municipality', label : 'Kommun' },
    { value : 'latest_email_notification', label : 'Senaste utskick' },
    { value : 'customer', label : 'Kundnamn' },
    { value : 'status_label', label : 'Status', component: 'address-status' },
    { value : 'address_type_label', label : 'Fastighetstyp' },
    { value : 'activated', label : 'Driftsatt - DO NOT USE', component: 'delivery-project-address-list-item-delivery-phase' },
];

const columnValuesMapping = (address, column) => {
    switch (column.value) {
        case 'installation':
        case 'dig':
        case 'activation':
        case 'activated':
            return null; // Is handled in the column component instead
        case 'operational':
            const operationalPhase = address.delivery_phases.find((phase) => phase.type === column.value);

            if (! operationalPhase || ! operationalPhase.completed) {
                return '-';
            }

            return operationalPhase.completed_at;
        case 'latest_email_notification':
            if (! address.customer || ! address.customer.latest_email_notification) {
                return '-';
            }

            const notification = address.customer.latest_email_notification;

            return `${notification.subject} (${format(notification.created_at, 'YYYY-MM-DD')})`;
        case 'customer':
            return address.customer ? valueWithFallback(address.customer.name) : '-';
        default:
            return valueWithFallback(address[column.value]);
    }
};

const valueWithFallback = (value) => value ? value : '-';

export default {
    namespaced: true,
    state: {
        ...toggleTableColumns.state,
        storeName: 'deliveryProjectAddressesTable',
        selectedColumns: [],
        defaultColumns,
        allColumns,
    },
    getters: {
        ...toggleTableColumns.getters,
        mappedColumnValue: () => (model, column) => columnValuesMapping(model, column),
    },
    actions: toggleTableColumns.actions,
    mutations: toggleTableColumns.mutations,
};
